function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "gpu");

var SvgGpu = function SvgGpu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M128,144H496V400H128Z",
    style: {
      fill: "#4d5d79"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 272,
    r: 96,
    style: {
      fill: "#3c98f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,64H80V496h48V16H16Z",
    style: {
      fill: "#88929f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,96H32V256a16,16,0,0,1,0,32v32a16,16,0,0,1,0,32V480H80Z",
    style: {
      fill: "#4d5d79"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,112H480v32H160Z",
    style: {
      fill: "#88929f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,400h96v32H160Z",
    style: {
      fill: "#88929f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,400h96v32H288Z",
    style: {
      fill: "#88929f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,400h32v32H416Z",
    style: {
      fill: "#88929f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 272,
    r: 24,
    style: {
      fill: "#c7e2fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.22,179.46,273,187.72A84.64,84.64,0,0,0,248,248v1.47a22.5,22.5,0,0,1,16,0V248a68.76,68.76,0,0,1,20.29-49l13.4-13.41a95.62,95.62,0,0,0-16.47-6.16Z",
    style: {
      fill: "#2a74c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,188.94V200a84.61,84.61,0,0,0,25,60.28l1.43,1.43a24.06,24.06,0,0,1,11.31-11.31L244.29,249A68.76,68.76,0,0,1,224,200V181.58A96.33,96.33,0,0,0,208,188.94Z",
    style: {
      fill: "#2a74c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,264a68.84,68.84,0,0,1-49-20.28l-13.4-13.41a95.93,95.93,0,0,0-6.16,16.47l8.26,8.25A84.66,84.66,0,0,0,232,280h1.47a22.5,22.5,0,0,1,0-16Z",
    style: {
      fill: "#2a74c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.4,282.29,233,283.72A68.8,68.8,0,0,1,184,304H165.58a95.53,95.53,0,0,0,7.36,16H184a84.7,84.7,0,0,0,60.29-25l1.43-1.43A24,24,0,0,1,234.4,282.29Z",
    style: {
      fill: "#2a74c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,294.53V296a68.76,68.76,0,0,1-20.29,49l-13.4,13.41a95.62,95.62,0,0,0,16.47,6.16l8.25-8.26A84.64,84.64,0,0,0,264,296v-1.47a22.5,22.5,0,0,1-16,0Z",
    style: {
      fill: "#2a74c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.6,282.29a24.06,24.06,0,0,1-11.31,11.31l1.43,1.43A68.8,68.8,0,0,1,288,344v18.42a95.53,95.53,0,0,0,16-7.36V344a84.61,84.61,0,0,0-25-60.28Z",
    style: {
      fill: "#2a74c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.29,289A84.7,84.7,0,0,0,280,264h-1.47a22.5,22.5,0,0,1,0,16H280a68.84,68.84,0,0,1,49,20.28l13.4,13.41a96.24,96.24,0,0,0,6.16-16.47Z",
    style: {
      fill: "#2a74c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.42,240a95.53,95.53,0,0,0-7.36-16H328a84.7,84.7,0,0,0-60.29,25l-1.42,1.43a24,24,0,0,1,11.31,11.31l1.43-1.43A68.8,68.8,0,0,1,328,240Z",
    style: {
      fill: "#2a74c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,176h80v80H384Z",
    style: {
      fill: "#c1c8d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,336h32v32H368Z",
    style: {
      fill: "#c1c8d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,336h32v32H432Z",
    style: {
      fill: "#c1c8d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,280h16v16H400Z",
    style: {
      fill: "#f5b95b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,296h16v16H432Z",
    style: {
      fill: "#f5b95b"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGpu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gpu.2f2fca3f.svg";
export { ForwardRef as ReactComponent };